import React from "react";

export default function UniversalFooter() {
  return (
    <div data-figma-id="121:8965" class="home-desktop">
      <div data-figma-id="121:8941" class="footer">
        <div data-figma-id="121:8942" class="footer-textos">
          <p data-figma-id="121:8943" class="footer-texto-1">
            ¿No encuentras el tema que buscabas?
          </p>
          <p data-figma-id="121:8944" class="footer-texto-2">
            Contáctanos y lo desarrollamos para ti.
          </p>
        </div>
        <div data-figma-id="121:8945" class="footer-contacto">
          <div data-figma-id="121:8946" class="footer-contacto-telefono">
            <img src="images/whatsapp-1.svg" data-figma-id="121:8958" class="img-31" />
            <p data-figma-id="121:8948" class="footer-contacto-telefono-texto">
              +52 55 6894 0926
            </p>
          </div>
          <div data-figma-id="121:8949" class="footer-contacto-mail">
            <img src="images/envelope-4-1.svg" data-figma-id="121:8962" class="img-32" />
            <p data-figma-id="121:8951" class="footer-contacto-mail-texto">
              contacto@mhm.com.mx
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
